/***
 * Created on 2023/7/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import Table from "../common/table/table";
import ContactRow from "./contact_row";
import {useTranslation} from "react-i18next";


function ContactTable({data}) {
    const { t } = useTranslation();
    const [currentSortType, setCurrentSortType] = useState(t('@Nickname@'));
    const [sortDirection, setSortDirection] = useState('asc');

    const contactTableFields = [
        {
            id: 1,
            name: t('@Nickname@'),
            size: 32,
            sortable: true
        },
        {
            id: 2,
            name: t('@Email or Phone@'),
            size: 32,
            sortable: true
        },
        {
            id: 3,
            name: t('@Add at@'),
            size: 26,
            sortable: false
        },
        {
            id: 4,
            name: t('@Action@'),
            size: 10,
            sortable: false,
            isAction: true
        }
    ];

    return (
        <Table fieldNameList={contactTableFields} currentSortType={currentSortType} setCurrentSortType={setCurrentSortType} sortDirection={sortDirection} setSortDirection={setSortDirection}>
            {
                data && data.length > 0 && data.sort((a, b) => {
                    if (currentSortType === t('@Nickname@')) {
                        return sortDirection === 'desc' ? b?.nickname?.localeCompare(a?.nickname) : a?.nickname?.localeCompare(b?.nickname);
                    }
                    else if (currentSortType === t('@Email or Phone@')) {
                        return sortDirection === 'desc' ? b?.email?.localeCompare(a?.email) : a?.email?.localeCompare(b?.email);
                    }
                }).map(row => (
                    <ContactRow fieldList={contactTableFields} data={row} key={row._id}/>
                ))
            }
        </Table>
    );
}

export default ContactTable;